import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckRanMonitoringStatuses } from '@api/consistencyCheck';

import { optionsFormattedByTitleName } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_RAN_MONITORING_STATUSES } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckRanMonitoringStatuses {
	monitoringOptions: TSelectOption<string>[];
	isLoadingMonitoringOptions: boolean;
}

const useQueryConsistencyCheckRanMonitoringStatuses = (): IUseQueryConsistencyCheckRanMonitoringStatuses => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONSISTENCY_RAN_MONITORING_STATUSES],
		queryFn: getConsistencyCheckRanMonitoringStatuses,
		select: (data) => optionsFormattedByTitleName(data),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		monitoringOptions: data || [],
		isLoadingMonitoringOptions: isInitialLoading,
	};
};

export default useQueryConsistencyCheckRanMonitoringStatuses;
